import { styled } from '@material-ui/core';

import { domTag } from '../../../../../utils/styledFilter';

export const RoleSelectorContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '0.75rem',
});

export const RoleSelectorLabel = styled('label')({
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-label-size)',
	'lineHeight': 'var(--leading-normal)',
	'color': 'var(--color-text-primary)',
	'marginBottom': '0.25rem',
	'& span': {
		color: 'var(--color-error)',
	},
});

export const RoleOptionWrapper = styled(domTag('div', ['selected']))(({ selected }: { selected: boolean }) => ({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'space-between',
	'padding': '16px 20px',
	'border': `1.5px solid ${selected ? 'var(--color-brand-primary)' : 'var(--color-border-default)'}`,
	'borderRadius': '10px',
	'backgroundColor': selected ? 'var(--color-brand-primary-light)' : 'var(--color-bg-secondary)',
	'cursor': 'pointer',
	'transition': 'all 0.2s ease',
	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		backgroundColor: selected ? 'var(--color-brand-primary-light)' : 'var(--color-bg-tertiary)',
	},
}));

export const RoleOptionLeft = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
});

export const RoleRadioCustom = styled(domTag('div', ['selected']))(({ selected }: { selected: boolean }) => ({
	'width': '20px',
	'height': '20px',
	'minWidth': '20px',
	'borderRadius': '50%',
	'border': `2px solid ${selected ? 'var(--color-brand-primary)' : 'var(--color-border-default)'}`,
	'backgroundColor': 'var(--color-bg-elevated)',
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'transition': 'all 0.2s ease',
	'&::after': {
		content: '""',
		width: '10px',
		height: '10px',
		borderRadius: '50%',
		backgroundColor: selected ? 'var(--color-brand-primary)' : 'transparent',
		transition: 'all 0.2s ease',
	},
}));

export const RoleLabelText = styled('span')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-snug)',
	color: 'var(--color-text-primary)',
});

export const LearnMoreLink = styled('button')({
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-body-sm-size)',
	'lineHeight': 'var(--leading-normal)',
	'color': 'var(--color-brand-primary)',
	'background': 'none',
	'border': 'none',
	'cursor': 'pointer',
	'padding': '4px 8px',
	'borderRadius': 'var(--radius-sm)',
	'transition': 'all 0.2s ease',
	'textDecoration': 'none',
	'&:hover': {
		textDecoration: 'underline',
		backgroundColor: 'var(--color-brand-primary-light)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-brand-primary)',
		outlineOffset: '2px',
	},
});

export const InputError = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-error)',
	margin: '0.25rem 0 0',
});

export const ModalContent = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '1.5rem',
	padding: '0.5rem',
});

export const ModalSection = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '0.5rem',
});

export const ModalSectionTitle = styled('h6')({
	fontFamily: 'var(--font-family-semibold)',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-snug)',
	color: 'var(--color-text-primary)',
	margin: 0,
});

export const ModalSectionText = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-relaxed)',
	color: 'var(--color-text-secondary)',
	margin: 0,
});

export const ModalList = styled('ul')({
	'fontFamily': 'var(--font-family-regular)',
	'fontSize': 'var(--text-body-sm-size)',
	'lineHeight': 'var(--leading-relaxed)',
	'color': 'var(--color-text-secondary)',
	'margin': 0,
	'paddingLeft': '1.25rem',
	'& li': {
		marginBottom: '0.25rem',
	},
});

export const ModalFooter = styled('div')({
	display: 'flex',
	justifyContent: 'flex-end',
	paddingTop: '0.5rem',
	borderTop: '1px solid var(--color-border-subtle)',
});
